import React from "react";
import {
  Box,
  Modal,
  Typography,
  Autocomplete,
  TextField,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface ModalAddVehicleProps {
  open: boolean;
  onClose: () => void;
  companies: any[];
  selectedCompany: any;
  setSelectedCompany: (company: any) => void;
  setSelectedCompanyId: (companyId: number | null) => void;
  handleSelectCompany: () => void;
}

const ModalAddVehicle: React.FC<ModalAddVehicleProps> = ({
  open,
  onClose,
  companies,
  selectedCompany,
  setSelectedCompany,
  setSelectedCompanyId,
  handleSelectCompany,
}) => {
  return (
    <Modal open={open} disableEscapeKeyDown disableEnforceFocus>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: 350, sm: 400 },
          bgcolor: "background.paper",
          border: "2px solid #000",
          boxShadow: 24,
          p: 4,
        }}
      >
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>

        <Typography variant="h6" component="h2" gutterBottom mb={3}>
          Selecionar Empresa
        </Typography>

        <Autocomplete
          options={companies}
          getOptionLabel={(option) => option.nome_empresa}
          value={selectedCompany}
          onChange={(event, newValue) => {
            setSelectedCompany(newValue);
            setSelectedCompanyId(newValue?.id ?? null);
          }}
          noOptionsText="Nenhuma empresa encontrada!"
          componentsProps={{
            popper: {
              disablePortal: true,
              style: { zIndex: 1301 },
            },
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Empresa"
              variant="outlined"
              fullWidth
            />
          )}
        />

        <Button
          variant="contained"
          onClick={handleSelectCompany}
          disabled={!selectedCompany}
          fullWidth
          sx={{
            mt: 5,
            backgroundColor: "#1d1d1d",
            ":hover": { bgcolor: "#5c5c5c" },
          }}
        >
          Selecionar Empresa
        </Button>
      </Box>
    </Modal>
  );
};

export default ModalAddVehicle;
